// extracted by mini-css-extract-plugin
export default {"titleR":"index_titleR_ZnvUN clearfix"};